module.exports = __webpack_public_path__ + "img/menuIcon15.9e4f7be9.png";